package com.ervasstudio.tracoemovimento.util

sealed class AuthState {
    data object Idle : AuthState()
    data object Loading : AuthState()
    data class Success(val userId: String, val email: String?) : AuthState()
    data class Error(val message: String) : AuthState()
}